import '../../../generic_avatar_view.coffee';# Added by Script 
Namespace 'Monitoring.Views.LinkedIn'

class Monitoring.Views.LinkedIn.LinkedInAvatarView extends Monitoring.Views.GenericAvatarView
  template: JST['backbone/templates/monitoring/social_contents/linkedin/linkedin_avatar']

  initialize: (socialContent) ->
    @avatar = socialContent.avatar()
    @type = socialContent.type()

  render: =>
    @$el.html @template
      view_id: @cid
      avatar_url: @avatar
      type: @type
